// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__r5NuU","row":"ProcedureTreatmentSummary_row__paglv"};